import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import TrafficPage from "@/pages/TrafficPage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function App() {
  // null = checking, false = not authenticated, object = user
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Check existing session on mount
    const checkAuth = async () => {
      try {
        const { data } = await axios.get(`${API}/auth/me`, { withCredentials: true });
        setUser(data);
      } catch {
        setUser(false);
      }
    };
    checkAuth();
  }, []);

  const handleLogin = useCallback((userData) => {
    setUser(userData);
  }, []);

  const handleLogout = useCallback(async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (err) {
      console.warn('Logout request failed, clearing local session anyway:', err);
    }
    setUser(false);
  }, []);

  // Loading state while checking auth
  if (user === null) {
    return (
      <div className="App">
        <div className="login-container">
          <div className="loading-spinner-container">
            <img 
              src="https://customer-assets.emergentagent.com/job_presenter-toolbox/artifacts/xguxj4wx_KL1%20Logo-01.png" 
              alt="KL1 Radio Logo" 
              className="login-logo pulse-animation"
            />
          </div>
        </div>
      </div>
    );
  }

  const isAuthenticated = !!user;

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route 
            path="/login" 
            element={
              isAuthenticated ? 
              <Navigate to="/dashboard" replace /> : 
              <LoginPage onLogin={handleLogin} />
            } 
          />
          <Route 
            path="/dashboard" 
            element={
              isAuthenticated ? 
              <DashboardPage onLogout={handleLogout} user={user} /> : 
              <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/traffic" 
            element={
              isAuthenticated ? 
              <TrafficPage /> : 
              <Navigate to="/login" replace />
            } 
          />
          <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
